import { EmptyString } from "utils/Constant";


export const checkRole = (user_role = "", role = "") => {
   const userRole = user_role?.toLowerCase();
   return userRole === role
}

export const RoundTwoDecimals = (number = 0) => {
   return Math.round((number + Number.EPSILON) * 100) / 100;
};

export const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");

export const money = event => {
   return (addCommas(removeNonNumeric(event)))
}

export const GetStatus = e => {
   let status = EmptyString
   
   if (e.toString() === "1"){
      status = "Active"
   }else if(e.toString() === "2"){
      status = "Deleted"
   }else if(e.toString() === "3"){
      status = "Pending"
   }else if(e.toString() === "4"){
      status = EmptyString
   }else{
      status = EmptyString
   }
   
   return status
}

export const GetPaymentType = e => {
   let paymentType = EmptyString

   if (e.toString() === "1"){
      paymentType = "Termin 1"
   }else if(e.toString() === "2"){
      paymentType = "Termin 2"
   }else if(e.toString() === "3"){
      paymentType = "Termin 3"
   }else if(e.toString() === "4"){
      paymentType = "Termin 4"
   }else if(e.toString() === "5"){
      paymentType = "Termin 5"
   }
   else if(e.toString() === "6"){
      paymentType = "Comfee"
   }else{
      paymentType = EmptyString
   }

   return paymentType
}


